import React from "react";
import { Box } from "@mui/material";

export const MyTimesheetDivider = ({
  width = "2px",
  backgroundColor = "#C6CACC",
  marginBottom = "16px",
}) => {
  return (
    <Box
      style={{
        height: width,
        backgroundColor: backgroundColor,
        marginBottom: marginBottom,
      }}
    />
  );
};

export default MyTimesheetDivider;
